// extracted by mini-css-extract-plugin
export default {"container":"_3IROxvolO4U-JqPJE0KHjk","color":"TdYWSdg9RHhl5Vx0G_m6"};